import { render, staticRenderFns } from "./TransferInformationSummary.vue?vue&type=template&id=2afcfa9e&scoped=true"
import script from "./TransferInformationSummary.vue?vue&type=script&lang=js"
export * from "./TransferInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./TransferInformationSummary.vue?vue&type=style&index=0&id=2afcfa9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afcfa9e",
  null
  
)

export default component.exports